import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { ICity } from 'models/city';
import { ICountry } from 'models/country';
import { IVendor } from 'models/vendor';
import { IVenue } from 'models/venue';
import { useTranslation } from 'react-i18next';
import MapInput from '../map-inbut';


interface Props {
  open: boolean;
  loading: boolean;
  Venue: IVenue;
  cities: ICity[];
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const EditVenue: React.FC<Props> = ({ open, loading, Venue, cities, onClose, onSubmit, onChanges }) => {
  let cityOptions = cities.map((city) => {
    return {
      value: city.cityId,
      label: city.cityName,
    };
  });

  const {t}=useTranslation()
  let basicFields: IFormField[] = [
    {
      name: 'cityId',
      label: t('T_city'),
      type: InputTypes.SELECT,
      placeholder: t('T_select_city'),
      options: cityOptions,
      multiple: false,
      defaultValue: cityOptions.find((x) => x.value === Venue.cityId),
      internalLabel: true,
      required: true
    },
    {
      name: 'name',
      label: t('T_name'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_name'),
      internalLabel: true,
      defaultValue: Venue.name,
      required: true
    },
    {
      name: 'nameAr',
      label: `${t('T_name')} ${t('T_in_arabic')}` ,
      type: InputTypes.TEXT,
      placeholder: `${t('T_enter_name')} ${t('T_in_arabic')}` ,
      internalLabel: true,
      defaultValue: Venue.nameAr,
      required: true
    },
  
  ];


  const setCoords = (lat: number, lng: number) => {
    onChanges('latitude', lat)
    onChanges('longitude', lng)
  }


  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_venue')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
        <MapInput setCoords={setCoords} lat={Venue.latitude} lng={Venue.longitude}/>
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
                {t('T_save')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditVenue;
